import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';

const honeycombWebSDK = new HoneycombWebSDK({
  debug: process.env.NODE_ENV === 'development',
  serviceName: import.meta.env.VITE_OTEL_SERVICE_NAME,
  endpoint: import.meta.env.VITE_OTEL_WEB_TRACER_ENDPOINT,
  apiKey: 'DO NOT USE API KEY IN CLIENT SIDE CODE!!!',
  instrumentations: [],
  webVitalsInstrumentationConfig: {
    enabled: false,
  },
  sampleRate: 5,
});

export default honeycombWebSDK;
